import SectionRecord from "models/view-models/section-record";
import { AdditionalBlockData } from "./additional-block-data";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import { CodeReferenceBlockHighlightRecord } from "models/view-models/code-reference-block-highlights/code-reference-block-highlight-record";

export interface AdditionalCodeReferenceBlockData extends AdditionalBlockData {
    section: SectionRecord | null;
    highlights?: CodeReferenceBlockHighlightRecord[];
}

export const isCodeReferenceAdditionalData = (
    data: AdditionalBlockData
): data is AdditionalCodeReferenceBlockData => {
    const section = (data as AdditionalCodeReferenceBlockData).section;

    if (section === undefined) {
        return false;
    }

    return section === null || RecordUtils.isRecord(section, SectionRecord);
};
